import React, { createContext, useContext } from 'react';

const RouteDataContext = createContext({ setCurrentRoute: () => {}, currentRoute: null });

export const useRouteData = () => useContext(RouteDataContext);

export const RouteDataProvider = ({ value, children }) => {
  return <RouteDataContext.Provider value={value}>{children}</RouteDataContext.Provider>;
};
